export default {
    state: {
        partnersList: [], // 合作方
        partnersAcquiesce: {}
    },
    getters: {

    },
    mutations: {
        getPartnersList(state, partnersList) { // 合作方
            state.partnersList = partnersList
        },
        setPartnersAcquiesce(state, partnersObj) {
            state.partnersAcquiesce = partnersObj
        }
    },
    actions: {

    }
}



// WEBPACK FOOTER //
// ./src/store/modules/partnersList.js